import { make } from "vuex-pathify"

const state = function () {
  return {
    isAuthenticated: false,
    id: null,
    emailAddress: null,
    accessToken: null,
    refreshToken: null,
    profileID: null,
    lastLogin: null,
    loginAttempts: 0,
    accountStatus: 'inactive' // 'active', 'inactive', 'suspended'
  }
}

// automatically generate operations
const getters = { 
  ...make.getters(state),
  
  // Additional computed getters
  hasValidToken: state => {
    return state.accessToken && state.accessToken.length > 0
  },
  
  isAccountActive: state => {
    return state.accountStatus === 'active'
  },
  
  canLogin: state => {
    return state.loginAttempts < 5 && state.accountStatus !== 'suspended'
  }
}

const mutations = {
  ...make.mutations(state),

  // Additional mutations
  incrementLoginAttempts(state) {
    state.loginAttempts++
  },
  
  resetLoginAttempts(state) {
    state.loginAttempts = 0
  },

  // setting the store back to it's initial state (logout, etc.)
  reset(s) {
    Object.assign(s, state())
  },
}

const actions = { 
  ...make.actions(state),
  
  // Additional actions
  login({ commit }, { user, tokens }) {
    commit('setIsAuthenticated', true)
    commit('setId', user.id)
    commit('setEmailAddress', user.email)
    commit('setAccessToken', tokens.accessToken)
    commit('setRefreshToken', tokens.refreshToken)
    commit('setProfileID', user.profileID)
    commit('setLastLogin', new Date().toISOString())
    commit('setAccountStatus', 'active')
    commit('resetLoginAttempts')
  },
  
  logout({ commit }) {
    commit('reset')
  },
  
  recordLoginAttempt({ commit }) {
    commit('incrementLoginAttempts')
  },
  
  resetLoginAttempts({ commit }) {
    commit('resetLoginAttempts')
  },
  
  activateAccount({ commit }) {
    commit('setAccountStatus', 'active')
  },
  
  suspendAccount({ commit }) {
    commit('setAccountStatus', 'suspended')
  },
  
  deactivateAccount({ commit }) {
    commit('setAccountStatus', 'inactive')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
